// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Lock } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconLock(props: any) {
    return <IconBase icon={Lock} {...props} />
  }

  export default IconLock
  